module.exports = __webpack_public_path__ + "static/media/soba.7b524a6a.png";